import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../../config/api";


export const getNotification = createAsyncThunk('notification/get', async (page) => {
    try {
        const request = await apiInstance.get(`/api/notification/notifications?pageNum=${page}`)
        const response = request.data
        if (response.status === 'success') {
            return response.notifications
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('unable to get notification ; ', error.message)
        throw new Error(error.message)
    }
})


export const readNotification = createAsyncThunk('notification/read', async (notificationId) => {
    try {
        const request = await apiInstance.put(`/api/notification/notifications/${notificationId}/read`)
        const response = request.data
        if (response.status === 'success') {
            return notificationId
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        // console.log('unable to get notification ; ', error.message)
        throw new Error(error.message)
    }
})


export const readAllNotifications = createAsyncThunk('notification/readAll', async () => {
    try {
        const request = await apiInstance.put('/api/notification/notifications/read-all', {})
        const response = request.data
        if (response.status === 'success') {
            return response.updatedCount // or whatever your API returns
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('unable to mark all as read: ', error.message)
        throw new Error(error.message)
    }
})